import FlatButtons from "../FlatButton/FlatButton"
import Typography from "../Typography/Typography"
import { tag, star } from "../../assets/svgs"
import styles from "./style.module.css"

interface cardProp {
    id: string
    image: string
    name: string
    price: number
    rate: number
    review: number
    detail: string
}

export const FavouriteCard: React.FC<cardProp> = ({
    id,
    image,
    name,
    price,
    rate,
    review,
    detail,
}) => {

    return (
        <div className={styles.container}>

            <div className={styles.imgContainer}>
                <img className={styles.img} src={image} alt="" />
            </div>

            <div>

                <div>

                    <Typography
                        className={`${styles.thickText} ${styles.name}`}
                    >
                        {name}
                    </Typography>

                    <div className={styles.priceRate}>

                        <div className={styles.priceRow}>

                            <div>
                                <img src={tag} alt="" />
                            </div>

                            <Typography
                                className={styles.thickText}
                            >

                                {`USD ${price}`}

                            </Typography>

                        </div>

                        <div className={styles.rateRow}>

                            <Typography>

                                {rate}

                            </Typography>

                            <div className={styles.starContainer}>

                                <img src={star} alt="" />

                            </div>

                            <Typography>

                                {`(${review} Reviews)`}

                            </Typography>

                        </div>


                    </div>

                </div>

            </div>

            <div>

                <Typography className={styles.detail}>

                    {detail}

                </Typography>

            </div>

            <div>

                <FlatButtons
                    onClick={() => {
                        console.log(id)
                    }}
                    className={styles.primaryButton}
                >
                    <Typography
                        variant="buttonText"
                        fontFamily="satoshi"
                        weight="regular"
                        size="base"
                        className={styles.primaryButtonText}
                    >
                        Add to cart
                    </Typography>
                </FlatButtons>

            </div>

        </div>
    )
}